<template>
  <div id="distributorFilterList">
    <div class="columns">
      <div class="column is-4">
        <div class="form-group">
          <label for="country">Country/Region</label>
          <select v-model="searchCountryFilter" id="country" class="form-control">
            <option v-for="(option) in countryOptions" :key="option.abbr" :value="option.abbr">{{ option.name }}</option>
          </select>
        </div>
      </div>
      <div class="column is-4">
        <label for="state">State</label>
        <div class="form-group">
          <select v-model="searchStateFilter" id="state" class="form-control" :disabled="searchCountryFilter !== 'US'">
            <option value="">Select One</option>
            <option v-for="(option) in stateOptions" :key="option.abbr" :value="option.abbr">{{ option.name }}</option>
          </select>
        </div>
      </div>
      <div class="column is-4">
        <div class="form-group">
          <label for="industry">Industry</label>
          <select v-model="searchIndustryFilter" id="industry" class="form-control">
            <option value="">Select One</option>
            <option v-for="(option) in industryOptions" :key="option.id" :value="option.id">{{ option.name }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'

export default {
  name: 'DistributorSearchFilters',
  props: {
    countryFilter: Array,
    stateFilter: Array,
    industryFilter: Array,
    countryOptions: Array,
    stateOptions: Array,
    industryOptions: Array
  },
  setup (props, { emit }) {
    return {
      searchCountryFilter: useModelWrapper(props, emit, 'countryFilter'),
      searchStateFilter: useModelWrapper(props, emit, 'stateFilter'),
      searchIndustryFilter: useModelWrapper(props, emit, 'industryFilter')
    }
  }
}
</script>
